export default "__VITE_ASSET__Bo$S9ygZ__"